/**
 * Home page CMS cards — inject HTML body into card bodies while preserving links.
 */
(function () {
  'use strict';

  const CARD_SLUGS = ['home-card-camping', 'home-card-boyled', 'home-card-join'];
  const CARD_LINKS = {
    'home-card-camping': { href: 'about.html#philosophy', text: 'Our philosophy →' },
    'home-card-boyled': { href: 'about.html', text: 'Learn more →' },
    'home-card-join': { href: 'join.html', text: 'How to join →' },
  };

  async function patchCards() {
    for (const slug of CARD_SLUGS) {
      const el = document.getElementById('content-' + slug);
      const page = await Troop936Content.loadPage(slug);
      if (!el || !page?.body) continue;

      const wrap = document.createElement('div');
      wrap.innerHTML = Troop936Content.formatBody(page.body);
      const link = CARD_LINKS[slug];
      if (link) {
        const a = document.createElement('a');
        a.href = link.href;
        a.textContent = link.text;
        wrap.appendChild(a);
      }
      el.innerHTML = wrap.innerHTML;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCards);
  } else {
    patchCards();
  }
})();

export {};
